import React, { useEffect, useState } from 'react'; 
import Sidebar from './Sidebar'; 
import styles from './../../Assets/CSS/Style.module.css';
import { SmButton } from './../../Components/Button';
import axios from 'axios';
import { BASE_URL } from './../../Environment';
import { toast } from 'react-toastify';
import Info from './Info';
 
function Review() {
    const accessToken = localStorage.getItem('accessToken');
    useEffect(() => {
        document.title = 'Infomart | User Review';
    }, []);
    const [rating, setRating] = useState('');
    const [review, setReview] = useState('');
    const [isFeedbackLoading, setIsFeedbackLoading] = useState(false);
    const handleFeedback = async () => {
        setIsFeedbackLoading(true); 
        if (rating && rating < 1 || rating > 5) { 
            toast.error('Rating should be between 1 to 5.', { autoClose: 3000 });
            setIsFeedbackLoading(false);  
        } else { 
            await axios.post(`${BASE_URL}/user/review`, { rating, review }, {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${accessToken}`
                }
            }).then((res) => {
                setRating('');
                setReview('');
                toast.success(res.data.msg, { autoClose: 3000 });
                setIsFeedbackLoading(false);
            }).catch((res) => {
                toast.error(res.response.data.msg, { autoClose: 3000 });
                setIsFeedbackLoading(false);
            });
        }
    } 
    return (
        <div className="app"> 
            <div className="outlet">
                <Info />
                <div className="homeLayout">
                    <Sidebar />
                    <div className={styles.contactUsPageContainer}>
                        <h4>Review</h4>
                        <div className={styles.contactUsMain} style={{ justifyContent: 'center' }}>
                            <div className={styles.contactUsRight}>
                                <div className={styles.feedbackForm}>
                                    <h5>Feedback Form</h5>
                                    <div className={styles.inputContainer}>
                                        <input type="number" value={rating} placeholder="Rating" onChange={e => setRating(e.target.value)} />
                                    </div>
                                    <textarea value={review} placeholder="Review" onChange={e => setReview(e.target.value)} />
                                    <SmButton title={isFeedbackLoading ? "Loading..." : "Submit"} onClick={() => handleFeedback()} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> 
        </div>
    );
}

export default Review;       